import { combinedApi as api } from '@redux/combinedApi';
export const addTagTypes = ['ImportOperation'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getImportOperationById: build.query<GetImportOperationByIdApiResponse, GetImportOperationByIdApiArg>({
        query: (queryArg) => ({ url: `/ImportOperation/${queryArg}` }),
        providesTags: ['ImportOperation'],
      }),
      getImportOperationGetAll: build.query<GetImportOperationGetAllApiResponse, GetImportOperationGetAllApiArg>({
        query: () => ({ url: `/ImportOperation/get-all` }),
        providesTags: ['ImportOperation'],
      }),
      putImportOperation: build.mutation<PutImportOperationApiResponse, PutImportOperationApiArg>({
        query: (queryArg) => ({ url: `/ImportOperation`, method: 'PUT', body: queryArg }),
        invalidatesTags: ['ImportOperation'],
      }),
      postImportOperationRetryImportPlausibilityCheck: build.mutation<
        PostImportOperationRetryImportPlausibilityCheckApiResponse,
        PostImportOperationRetryImportPlausibilityCheckApiArg
      >({
        query: (queryArg) => ({
          url: `/ImportOperation/retry-import-plausibility-check`,
          method: 'POST',
          params: {
            importOperationId: queryArg,
          },
        }),
        invalidatesTags: ['ImportOperation'],
      }),
      postImportOperationRetryImportValidation: build.mutation<
        PostImportOperationRetryImportValidationApiResponse,
        PostImportOperationRetryImportValidationApiArg
      >({
        query: (queryArg) => ({
          url: `/ImportOperation/retry-import-validation`,
          method: 'POST',
          params: {
            importOperationId: queryArg,
          },
        }),
        invalidatesTags: ['ImportOperation'],
      }),
      postImportOperationRetryImportQuantile: build.query<
        PostImportOperationRetryImportQuantileApiResponse,
        PostImportOperationRetryImportQuantileApiArg
      >({
        query: (queryArg) => ({
          url: `/ImportOperation/retry-import-quantile`,
          method: 'POST',
          params: {
            importOperationId: queryArg,
          },
        }),
        providesTags: ['ImportOperation'],
      }),
      postImportOperationStartForceFullImport: build.query<
        PostImportOperationStartForceFullImportApiResponse,
        PostImportOperationStartForceFullImportApiArg
      >({
        query: (queryArg) => ({
          url: `/ImportOperation/start-force-full-import`,
          method: 'POST',
          params: {
            importOperationId: queryArg,
          },
        }),
        providesTags: ['ImportOperation'],
      }),
      postImportOperationStartPartialImport: build.query<
        PostImportOperationStartPartialImportApiResponse,
        PostImportOperationStartPartialImportApiArg
      >({
        query: (queryArg) => ({
          url: `/ImportOperation/start-partial-import`,
          method: 'POST',
          params: {
            importOperationId: queryArg,
          },
        }),
        providesTags: ['ImportOperation'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as importOperationApi };
export type GetImportOperationByIdApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoImportOperationExternalDto;
export type GetImportOperationByIdApiArg = number;
export type GetImportOperationGetAllApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoImportOperationExternalDto;
export type GetImportOperationGetAllApiArg = void;
export type PutImportOperationApiResponse = unknown;
export type PutImportOperationApiArg =
  ApiCommonRequestsBaseCrudRequest601ApiCommonExternalDtoImportOperationUpdateExternalDto;
export type PostImportOperationRetryImportPlausibilityCheckApiResponse = unknown;
export type PostImportOperationRetryImportPlausibilityCheckApiArg = number | undefined;
export type PostImportOperationRetryImportValidationApiResponse = unknown;
export type PostImportOperationRetryImportValidationApiArg = number | undefined;
export type PostImportOperationRetryImportQuantileApiResponse = unknown;
export type PostImportOperationRetryImportQuantileApiArg = number | undefined;
export type PostImportOperationStartForceFullImportApiResponse = unknown;
export type PostImportOperationStartForceFullImportApiArg = number | undefined;
export type PostImportOperationStartPartialImportApiResponse = unknown;
export type PostImportOperationStartPartialImportApiArg = number | undefined;
export type ApiDatabaseCommonUploadType = 0 | 1;
export type ApiDatabaseCommonValidationStatus = 1 | 2 | 3 | 4;
export type ApiDatabaseCommonValidationErrorReason = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
export type ApiDatabaseCommonImportStatus = 0 | 1 | 2 | 3 | 4 | 5 | 6;
export type ApiDatabaseCommonPlausibilityStatus = 0 | 1 | 2 | 3 | 4 | 6;
export type ApiDatabaseCommonQuantileCalculationStatus = 0 | 1 | 2 | 3;
export type ApiCommonExternalDtoImportOperationExternalDto = {
  id?: number;
  tsoId?: number;
  fileName: string;
  uploadType: ApiDatabaseCommonUploadType;
  uploadDate: string;
  from?: string | null;
  to?: string | null;
  validationStatus: ApiDatabaseCommonValidationStatus;
  validationErrorReason: ApiDatabaseCommonValidationErrorReason;
  validationErrorDetails: string;
  importStatus: ApiDatabaseCommonImportStatus;
  importErrorDetails: string;
  plausibilityStatus: ApiDatabaseCommonPlausibilityStatus;
  comment: string;
  measurementDeviceId?: number | null;
  aggregationIntervalId?: number | null;
  plausibilityErrorReason?: string | null;
  quantileCalculationStatus: ApiDatabaseCommonQuantileCalculationStatus;
};
export type ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoImportOperationExternalDto = {
  externalDto?: ApiCommonExternalDtoImportOperationExternalDto;
  externalDtos?: ApiCommonExternalDtoImportOperationExternalDto[] | null;
};
export type ApiCommonExternalDtoImportOperationUpdateExternalDto = {
  id?: number;
  tsoId?: number;
  measurementDeviceId?: number | null;
  aggregationIntervalId?: number | null;
};
export type ApiCommonRequestsBaseCrudRequest601ApiCommonExternalDtoImportOperationUpdateExternalDto = {
  externalDto?: ApiCommonExternalDtoImportOperationUpdateExternalDto;
};
export const {
  useGetImportOperationByIdQuery,
  useLazyGetImportOperationByIdQuery,
  useGetImportOperationGetAllQuery,
  useLazyGetImportOperationGetAllQuery,
  usePutImportOperationMutation,
  usePostImportOperationRetryImportPlausibilityCheckMutation,
  usePostImportOperationRetryImportValidationMutation,
  usePostImportOperationRetryImportQuantileQuery,
  useLazyPostImportOperationRetryImportQuantileQuery,
  usePostImportOperationStartForceFullImportQuery,
  useLazyPostImportOperationStartForceFullImportQuery,
  usePostImportOperationStartPartialImportQuery,
  useLazyPostImportOperationStartPartialImportQuery,
} = injectedRtkApi;
